import type { IconSvgObject } from './types';

const ArrangeByLettersAZIcon: IconSvgObject = [
  ["path", { d: "M4 14H9.4L4.6 21H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 9.5L7 3L10 9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17.5 4V19.3056M15 17.5L17.5 20L20 17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArrangeByLettersAZIcon;
